import React, { memo } from 'react';
import PropTypes from 'prop-types';
import cc from 'classcat';
import { easeLinear } from 'd3-ease';
import { Animate } from 'react-move';
import { isNil } from 'lodash';
import { formatCurrency } from 'lib/formatters';

const PrizeRow = ({ title, winner, jackpotAmount, showMore, balls, className, logoImageUrl }) => {
  let winnerName = null;
  const prizeRowClassName = cc([className, { 'prizeRow--won': winner }]);
  if (winner) {
    if (winner.result.length > 1) {
      winnerName = `${winner.result[0]} + ${winner.result.length - 1} more`;
    } else {
      winnerName = winner.result[0];
    }
  }

  return (
    <div className={prizeRowClassName} style={{ backgroundImage: `url('${logoImageUrl}')` }}>
      <span>{winner ? `${title} win ${formatCurrency(jackpotAmount)}` : title}</span>
      {!isNil(balls) ? <span className="jackBall progressiveJackpotBalls">{balls}</span> : null}
      {winner ? (
        <span className="gameJackpotAmount">{winnerName}</span>
      ) : (
        <Animate
          // Set some default data
          start={{
            scale: 1,
            jackpotAmount: jackpotAmount
          }}
          update={{
            jackpotAmount: [jackpotAmount],
            timing: { duration: 1000, ease: easeLinear }
          }}
        >
          {({ jackpotAmount: amount }) => (
            <span className="gameJackpotAmount">{formatCurrency(amount)}</span>
          )}
        </Animate>
      )}
      {showMore ? <div className="prizeRow__show-more" /> : null}
    </div>
  );
};
PrizeRow.propTypes = {
  jackpotAmount: PropTypes.number,
  balls: PropTypes.number,
  title: PropTypes.string,
  className: PropTypes.string,
  showMore: PropTypes.bool,
  logoImageUrl: PropTypes.string
};

PrizeRow.defaultProps = {
  jackpotAmount: 0,
  balls: null,
  title: '',
  className: '',
  showMore: false,
  logoImageUrl: ''
};

// PureComponent: SIMPLE props only, ALL children must be PURE too!
export default memo(PrizeRow);
